<template>
  <div class="myheader">
    <section class="logo" :class="{'minWidth':isCollapse}" :style="{'background':menuConfig.menu_background_color}">
      <a target="_blank"
        href=""
        class="logoLink">
        <img src="../../image/logo_w.png" alt="logo" />
        <span v-if="!isCollapse">公证综合业务系统</span>
      </a>
    </section>

    <section class="header-content">
      <section class="collspan dc cursor" @click="collspan">
        <img src="./images/close.png" alt="logo" v-if="!isCollapse" />
        <img src="./images/open.png" alt="logo" v-if="isCollapse" />
      </section>
      <div class="bread">
        <BreadCrumb></BreadCrumb>
      </div>
       <dark-birght/>
      <div style="margin-top: 20px; margin-right: 10px; font-size: small; color: #5f5f5f; cursor: pointer;"
           @click="goToUpdatePage">系统更新</div>
      <div style="margin-top: 20px; margin-right: 10px; font-size: small; color: #5f5f5f;">主题选择</div>
       <theme-picker class="theme-picker"></theme-picker>
      <section class="fullscreen cursor dc" @click="toggleFull">
        <img src="./images/fullscreen.png" alt="logo" />
      </section>
      <img class="header-img" :src="userInfo.headImg" style="cursor:pointer" alt @click="$refs.dialog.open()" />
      <section class="cursor dc">
        <el-dropdown @command="handleDropLink" trigger="click">
          <span class="el-dropdown-link">
            {{userInfo.username}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">
              退出登录
            </el-dropdown-item>
            <el-dropdown-item command="2">
              修改密码
            </el-dropdown-item>
            <el-dropdown-item command="3">
              修改头像
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </section>
    </section>
    <Dialog title="修改头像" ref="dialog" width="400px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="80px" class="orgForm">
        <el-form-item label="头像">
          <UploadImage :imgUrl="ruleForm.headImg" @successUpload="successUpload"/>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submitForm('ruleForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import screenfull from "screenfull";
import { mapGetters } from "vuex";
import BreadCrumb from "./BreadCrumb";
import Utils from "src/assets/scripts";
import myRoutes from "../../router/routes.js";
import initialRouter from "../../router/initial_router.js";
import { myConfirm } from "@/utils/tools";
import ThemePicker from "@/components/theme-picker";
import DarkBirght from "@/components/dark_birght";
import { birght, dark } from "./menuTheme.js";
import Dialog from '@/components/dialog.vue';
import UploadImage from '@/components/upload-image.vue';

export default {
  name: "myheader",
  data() {
    return {
      // userInfo: {},
      userName: "",
      menuConfig: null,
      ruleForm: {
        headImg: ''
      }
    };
  },
  components: {
    BreadCrumb,
    ThemePicker,
    DarkBirght,
    Dialog,
    UploadImage
  },
  computed: {
    ...mapGetters({
      isCollapse: "app/isCollapse",
      menuTheme: "app/menuTheme",
      userInfo: "login/userInfo"
    })
  },
  created() {
    this.userName = localStorage.getItem('userName');
    this.menuTheme === "birght" ? (this.menuConfig = birght) : (this.menuConfig = dark);
    this.ruleForm.headImg = this.userInfo.headImg;
  },
  watch: {
    menuTheme(val) {
      val === "birght" ? (this.menuConfig = birght) : (this.menuConfig = dark);
    }
  },
  methods: {
    collspan() {
      this.$store.commit("app/updateCollapse", !this.isCollapse);
    },
    handleDropLink(index) {
      if (index == 1) {
        myConfirm({
          text: "是否确认退出",
          success:()=> {
            localStorage.clear();
            this.clearRoutes().then(res => {
              eventBus.$emit('closeSocket');
              this.$router.push("/login");
            });
          }
        });
      } else if (index == 2) {
        this.$prompt('请输入新密码', '修改密码', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /[0-9a-zA-Z]{6,12}/,
          inputErrorMessage: '请输入6-12位字母、数字或字母数字组合。'
        }).then(({ value }) => {
          let userId = this.$store.state.login.userInfo.id;
          console.log(userId, value)
          this.$api.changePassword({
            userId: userId,
            password: value
          }).then(res => {
            if (res.data.code === '200') {
              this.$message({
                type: 'success',
                message: '密码修改成功'
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              });
            }
          })
        }).catch(() => {

        });
      } else if (index == 3) {
        this.$refs.dialog.open();
      }
    },
    // 添加跳转到更新页面的方法
    goToUpdatePage() {
      this.$router.push('/system/update');
      // 检查用户是否有权限（根据实际业务逻辑调整）
      // const userRoles = this.$store.state.login.userInfo.roles || [];
      // const allowedRoles = ['admin', 'maintainer']; // 允许访问的角色
      // if (allowedRoles.some(role => userRoles.includes(role))) {
      //   this.$router.push('/system/update');
      // } else {
      //   this.$message.warning('您没有权限访问系统更新页面');
      // }
    },
    // 清除路由缓存
    clearRoutes() {
      return new Promise(resolve => {
        myRoutes.splice(0,myRoutes.length) // 清空
        myRoutes.push(...initialRouter)// 恢复为初始路由
        console.log(myRoutes)
        this.$router.options.routes = myRoutes;
        this.$router.addRoutes(myRoutes);
        resolve();
      });
    },
    toggleFull() {
      if (!screenfull.enabled) {
        this.$message({
          type: "warning",
          message: "you browser can not work"
        });
        return false;
      }
      screenfull.toggle();
    },
    // 头像上传成功
    successUpload(url) {
      this.ruleForm.headImg = url;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.ruleForm);
          this.$api.updateHeadImg({
            userId: this.userInfo.id,
            headImg: this.ruleForm.headImg
          }).then(res => {
            if (res.data.code === '200') {
              this.$message({
                message: '头像上传成功',
                type: 'success'
              });
              this.$store.commit('login/updateHeadImg', this.ruleForm.headImg);
              this.$refs.dialog.close();
            } else {
              this.$message({
                message: red.data.msg,
                type: 'warning'
              });
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.theme-picker{
  align-self: center;
  margin-right: 20px;
}
.myheader {
  position: relative;
  z-index: 10;
  display: flex;
  width: 100%;
  height: 50px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .logo {
    overflow: hidden;
    width: 200px;
    // border-bottom: 1px solid #454b61;
    transition: width 0.3s;
    &.minWidth {
      width: 64px !important;
    }
  }
  .logoLink {
    display: inline-block;
    margin-left: 18px;
    height: 100%;
    color: #fff;
    font-weight: bold;
    font-size: 15px;
    line-height: 50px;
    img {
      position: relative;
      top: -3px;
      margin-right: 8px;
      height: 28px;
      vertical-align: middle;
    }
  }
  .header-content {
    display: flex;
    flex: 1;
    padding: 0 20px;
    .collspan {
      img {
        display: block;
      }
    }
    .bread {
      display: flex;
      align-items: center;
      flex: 1;
      padding-left: 15px;
    }
    .fullscreen {
      margin-right: 20px;
      img {
        display: block;
      }
    }
  }
}
.header-img {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-top: 5px;
  margin-right: 10px;
  // -moz-box-shadow:0px 0px 5px #949494; -webkit-box-shadow:0px 0px 5px #949494; box-shadow:0px 0px 5px #949494;
}
/* 添加悬停效果 */
div[style*="系统更新"]:hover {
  color: #409EFF !important; /* 使用主题色 */
  text-decoration: underline;
}
</style>
